import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Screen } from '@tempmee/react';
import { CenteredSpinner, Column, Text, BackButton } from '~/commonComponents';
import { useAppSelector } from '~/hooks';
import { FETCH_INVOICE_LIST, fetchInvoiceList } from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import { currencyFormat } from '../../../utils/currencyFormat';
import { PaymentInvoiceTable } from './components/InvoiceTable';
import '../../../themes/global.scss';

const LIMIT_VALUE = 25;

export default function InvoiceList() {
  const dispatch = useDispatch();
  const myRef = useRef<HTMLDivElement>(null);

  const loadingSelector = createLoadingSelector([FETCH_INVOICE_LIST]);
  const isLoading = useAppSelector((state) => loadingSelector(state));

  const {
    invoices,
    isFinalPageInvoices,
    isActiveRequestInvoices,
    receiptReport,
    invoicesPagination,
    totalUnpaid,
  } = useAppSelector((state) => state.job);

  const cvsDownload = useRef<{ link?: HTMLAnchorElement } | null>(null);

  useEffect(() => {
    dispatch(fetchInvoiceList({ page: 1, limit: LIMIT_VALUE }));
  }, [dispatch]);

  const handleScrollReceipts = () => {
    const userScrollHeight = window.innerHeight + window.scrollY + 1;
    const windowBottomHeight = document.documentElement.offsetHeight;

    if (userScrollHeight > windowBottomHeight && !isActiveRequestInvoices && !isFinalPageInvoices) {
      dispatch(fetchInvoiceList({ page: invoicesPagination?.page + 1, limit: LIMIT_VALUE }));
    }
  };

  useEffect(() => {
    if (cvsDownload.current?.link && receiptReport !== '') {
      cvsDownload.current.link.click();
    }
  }, [receiptReport]);

  if (isLoading && invoices.length === 0) {
    return (
      <Screen variant="standard">
        <Screen.Header start={<BackButton />} title="Invoices" />
        <Screen.Body>
          <CenteredSpinner minHeight={400} />
        </Screen.Body>
      </Screen>
    );
  }

  return (
    <Screen variant="standard">
      <Screen.Header
        start={<BackButton />}
        title="Invoices"
        end={
          <Column>
            <Text bold textAlign="right">
              Unpaid Invoices - {totalUnpaid.count}
            </Text>
            <Text bold textAlign="right">
              Total of Unpaid Invoices - ${currencyFormat(totalUnpaid.sum)}
            </Text>
          </Column>
        }
      />
      <Screen.Body>
        <PaymentInvoiceTable ref={myRef} onScroll={handleScrollReceipts} />
      </Screen.Body>
    </Screen>
  );
}
